<div class="banner" role="banner">
  <h1>{{ 'trivia.banner.text' | translate }}</h1>
</div>
<div class="trivia-v2-page">
  <fgb-leaderboard-v2-nav routeLink="trivia"></fgb-leaderboard-v2-nav>
  <router-outlet></router-outlet>
</div>
